import { Component, OnInit } from '@angular/core';
import {
  LastVsThisMonthSalesAmountSummaryCardComponent,
  DashboardKpiService,
  Timespan,
  SalesSummaryEntity
} from 'gung-dashboard';
import { forkJoin } from 'rxjs';
import { first } from 'rxjs';

@Component({
    selector: 'colmec-last-vs-this-month-sales-amount-summary-card',
    templateUrl: './colmec-last-vs-this-month-sales-amount-summary-card.component.html',
    styleUrls: ['./colmec-last-vs-this-month-sales-amount-summary-card.component.scss'],
    standalone: false
})
export class ColmecLastVsThisMonthSalesAmountSummaryCardComponent
  extends LastVsThisMonthSalesAmountSummaryCardComponent
  implements OnInit
{
  constructor(protected dashboardKpiService: DashboardKpiService) {
    super(dashboardKpiService);
  }

  ngOnInit() {
    const thisMonthSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.Month);
    const lastMonthSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.LastMonth);

    forkJoin({
      salesSummaryGroupsThisMonth: this.dashboardKpiService
        .getSalesSummary(SalesSummaryEntity.PRODUCT, thisMonthSpan.fromDate)
        .pipe(first()),
      salesSummaryGroupsLastMonth: this.dashboardKpiService
        .getSalesSummary(SalesSummaryEntity.PRODUCT, lastMonthSpan.fromDate, lastMonthSpan.toDate)
        .pipe(first())
    }).subscribe(({ salesSummaryGroupsThisMonth, salesSummaryGroupsLastMonth }) => {
      this.salesAmountThisMonth = salesSummaryGroupsThisMonth.reduce((acc, curr) => acc + curr.totalQuantity, 0);
      this.salesAmountLastMonth = salesSummaryGroupsLastMonth.reduce((acc, curr) => acc + curr.totalQuantity, 0);
      this.loaded = true;
    });
  }
}
